export const injectSchemaOrg = () => {
  const schema = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "LocalBusiness",
        "@id": `${import.meta.env.VITE_SITE_URL}/#organization`,
        "name": "McCrea's Landscaping & Irrigation",
        "url": import.meta.env.VITE_SITE_URL,
        "logo": `${import.meta.env.VITE_SITE_URL}/logo.png`,
        "image": `${import.meta.env.VITE_SITE_URL}/og-image.jpg`,
        "description": "Professional landscaping and irrigation services in Prattville, Alabama, and surrounding area since 2009. Expert lawn maintenance, landscape design, irrigation systems, hardscaping, and tree care.",
        "address": {
          "@type": "PostalAddress",
          "addressLocality": "Prattville",
          "addressRegion": "AL",
          "addressCountry": "US"
        },
        "geo": {
          "@type": "GeoCoordinates",
          "latitude": "32.3668",
          "longitude": "-86.3000"
        },
        "areaServed": [
          {
            "@type": "City",
            "name": "Prattville"
          },
          {
            "@type": "City",
            "name": "Montgomery"
          },
          {
            "@type": "County",
            "name": "Autauga County"
          },
          {
            "@type": "County",
            "name": "Elmore County"
          },
          {
            "@type": "County",
            "name": "Montgomery County"
          }
        ],
        "priceRange": "$$",
        "foundingDate": "2009",
        "serviceType": [
          "Landscaping",
          "Irrigation Systems",
          "Lawn Maintenance",
          "Landscape Design",
          "Hardscaping",
          "Tree Care"
        ]
      },
      {
        "@type": "WebSite",
        "@id": `${import.meta.env.VITE_SITE_URL}/#website`,
        "url": import.meta.env.VITE_SITE_URL,
        "name": "McCrea's Landscaping & Irrigation",
        "publisher": {
          "@id": `${import.meta.env.VITE_SITE_URL}/#organization`
        }
      },
      {
        "@type": "WebPage",
        "@id": `${import.meta.env.VITE_SITE_URL}/#webpage`,
        "url": import.meta.env.VITE_SITE_URL,
        "name": "McCrea's Landscaping & Irrigation | Prattville, AL",
        "description": "Professional landscaping and irrigation services in Prattville, Alabama, and surrounding area since 2009. Expert lawn maintenance, landscape design, irrigation systems, hardscaping, and tree care. Free estimates available.",
        "isPartOf": {
          "@id": `${import.meta.env.VITE_SITE_URL}/#website`
        },
        "about": {
          "@id": `${import.meta.env.VITE_SITE_URL}/#organization`
        }
      },
      {
        "@type": "Service",
        "serviceType": "Landscaping Services",
        "provider": {
          "@id": `${import.meta.env.VITE_SITE_URL}/#organization`
        },
        "areaServed": [
          {
            "@type": "City",
            "name": "Prattville",
            "containedInPlace": {
              "@type": "State",
              "name": "Alabama"
            }
          },
          {
            "@type": "City",
            "name": "Montgomery",
            "containedInPlace": {
              "@type": "State",
              "name": "Alabama"
            }
          },
          {
            "@type": "County",
            "name": "Autauga County",
            "containedInPlace": {
              "@type": "State",
              "name": "Alabama"
            }
          },
          {
            "@type": "County",
            "name": "Elmore County",
            "containedInPlace": {
              "@type": "State",
              "name": "Alabama"
            }
          },
          {
            "@type": "County",
            "name": "Montgomery County",
            "containedInPlace": {
              "@type": "State",
              "name": "Alabama"
            }
          }
        ],
        "hasOfferCatalog": {
          "@type": "OfferCatalog",
          "name": "Landscaping Services",
          "itemListElement": [
            {
              "@type": "Offer",
              "itemOffered": {
                "@type": "Service",
                "name": "Lawn Maintenance",
                "description": "Professional lawn care and maintenance services"
              }
            },
            {
              "@type": "Offer",
              "itemOffered": {
                "@type": "Service",
                "name": "Landscape Design",
                "description": "Custom landscape design and installation"
              }
            },
            {
              "@type": "Offer",
              "itemOffered": {
                "@type": "Service",
                "name": "Irrigation Systems",
                "description": "Professional irrigation system installation and repair"
              }
            },
            {
              "@type": "Offer",
              "itemOffered": {
                "@type": "Service",
                "name": "Hardscaping",
                "description": "Patios, walkways, and outdoor living spaces"
              }
            },
            {
              "@type": "Offer",
              "itemOffered": {
                "@type": "Service",
                "name": "Tree Care",
                "description": "Professional tree trimming and maintenance"
              }
            }
          ]
        }
      }
    ]
  };

  const scriptTag = document.getElementById('seo-schema');
  if (scriptTag) {
    scriptTag.setAttribute('type', 'application/ld+json');
    scriptTag.textContent = JSON.stringify(schema);
  }
};
